// File to translate the hard-committed library pickadate.js
//
// If a new language is needed:
// 1. Create a new <locale>.ts file (for example, "en.ts" or "pt-br.ts")
// 2. Copy the contents of the translations in https://github.com/amsul/pickadate.js/tree/3.5.6/lib/translations
// (or translate manually if none exists)
// 3. Import to this file (index.ts) and add to DATEPICKER_LOCALES
// NOTE: DO NOT copy this into the React version, instead find a datepicker that we can rely on without this hack.

import { settings as ar } from './ar';
import { settings as bg } from './bg';
import { settings as cs } from './cs';
import { settings as de } from './de';
import { settings as en } from './en';
import { settings as es } from './es';
import { settings as fr } from './fr';
import { settings as hr } from './hr';
import { settings as hu } from './hu';
import { settings as it } from './it';
import { settings as pl } from './pl';
import { settings as pt } from './pt';
import { settings as pt_br } from './pt-br';
import { settings as ro } from './ro';
import { settings as sk } from './sk';
import { settings as tr } from './tr';

const DATEPICKER_LOCALES: Record<string, Pickadate.DateOptions> = {
  ar,
  bg,
  cs,
  de,
  en,
  es,
  fr,
  hr,
  hu,
  it,
  pl,
  pt,
  'pt-br': pt_br,
  ro,
  sk,
  tr,
};

export function getDatePickerLocaleSettings(locale: string): Pickadate.DateOptions {
  if (DATEPICKER_LOCALES[locale]) {
    return DATEPICKER_LOCALES[locale];
  }

  const baseLanguage = locale.split('-')[0].toLowerCase();
  if (DATEPICKER_LOCALES[baseLanguage]) {
    return DATEPICKER_LOCALES[baseLanguage];
  }

  return DATEPICKER_LOCALES['en'];
}
